import { useTranslation } from 'react-i18next'
import React from 'react'

import Details from '../details/Details'
import WebhookCallsList from '../calls/WebhookCallsList'

export const useTabsOptions = () => {
  const { t } = useTranslation('webhook')

  return [
    { name: t('details'), render: () => <Details /> },
    { name: t('calls'), render: () => <WebhookCallsList /> }
  ]
}

// Mantido para compatibilidade, mas usar useTabsOptions é recomendado
export const tabsOptions = [
  { name: 'Detalhes', render: () => <Details /> },
  { name: 'Chamadas', render: () => <WebhookCallsList /> }
]
